/* loaded by smart-asset */
export default require("./calendar_today-24px~boSFxnqt.svg")